export const BOOKING_TIME = 'BOOKING_TIME'
export const BOOKING_DATE = 'BOOKING_DATE'
export const BOOKING_PEOPLE = 'BOOKING_PEOPLE'
export const BOOKING_ADDRESS_SELECT = 'BOOKING_ADDRESS_SELECT'
export const BOOKING_ADDRESS_CHANGE = 'BOOKING_ADDRESS_CHANGE'
export const CURRENT_ADDRESS = 'CURRENT_ADDRESS'
export const CURRENT_ADDRESS_ERROR = 'CURRENT_ADDRESS_ERROR'
export const LOCATION_POINT = 'LOCATION_POINT'
export const REMOVE_CLEAR_BUTTON = 'REMOVE_CLEAR_BUTTON'
